export default __webpack_public_path__ + "static/media/x.3b33db62.svg";